/**
 * Global state to keep track of which warnings have been shown
 */
const WARNINGS_STATE = {};
/**
 * Function to log a warning if an invalid prop is passed to a component
 * @param componentName The name of the component
 * @param prop The name of the prop
 * @param value The value of the prop
 * @param defaultValue The default value of the prop
 */
export const logErrorIfInvalidProp = (componentName, prop, value, defaultValue) => {
    const warningKey = `invalidProp-${componentName}-${prop}`;
    if (!WARNINGS_STATE[warningKey]) {
        const message = `Warning: Invalid value '${value !== null && value !== void 0 ? value : 'undefined'}' for prop '${prop}' in component '${componentName}'.${defaultValue !== undefined ? ` Defaulting to: '${defaultValue}'.` : ''}`;
        // eslint-disable-next-line no-console
        console.warn(message);
        WARNINGS_STATE[warningKey] = true;
    }
};
/**
 * Function to log a warning if a prop is deprecated
 * @param componentName The name of the component
 * @param prop The name of the prop
 *
 * @param message The deprecation message
 */
export const logDeprecationWarning = (componentName, message) => {
    const warningKey = `deprecation-${componentName}-${message}`;
    if (!WARNINGS_STATE[warningKey]) {
        // eslint-disable-next-line no-console
        console.warn(`Deprecation Warning in '${componentName}': ${message}`);
        WARNINGS_STATE[warningKey] = true; // Mark this warning as logged
    }
};
//# sourceMappingURL=errorHandling.js.map